export const CURRENT_ONBOARDING_VERSION = 2;
//# sourceMappingURL=onboarding.const.js.map